// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider  } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// TODO: Move firebaseConfig to environment variables for better security
const firebaseConfig = {
  apiKey: "AIzaSyAsAjClDdJ7MT7DCYd5Y2ZmObaN53tqtgI",
  authDomain: "pdp-optimization.firebaseapp.com",
  projectId: "pdp-optimization",
  storageBucket: "pdp-optimization.firebasestorage.app",
  messagingSenderId: "775225820577",
  appId: "1:775225820577:web:49d55d75f6567fe787b7e0",
  measurementId: "G-58F5847Z5Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const microsoftProvider= new OAuthProvider("microsoft.com")

export { auth, provider,analytics,microsoftProvider };